import DOMPurify from 'dompurify';

const ALLOWED_TAGS = [
  'a', 'audio', 'blockquote', 'br', 'code', 'del', 'div', 'em', 'figcaption', 'figure',
  'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'hr', 'img', 'input', 'li', 'mark', 'ol',
  'label', 'p', 'pre', 's', 'span', 'strong', 'sub', 'sup', 'u', 'ul', 'video'
];

const ALLOWED_ATTR = [
  'alt', 'checked', 'class', 'controls', 'data-checked', 'data-delete',
  'data-file-type', 'data-mime-type', 'data-size', 'data-type', 'disabled',
  'download', 'height', 'href', 'loading', 'rel', 'src', 'target',
  'title', 'type', 'width'
];

const ALLOWED_URI_REGEXP = /^(?:(?:https?|mailto|tel):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i;

const SANITIZE_CONFIG = {
  ALLOWED_TAGS,
  ALLOWED_ATTR,
  ALLOW_DATA_ATTR: false,
  ALLOWED_URI_REGEXP,
  FORBID_TAGS: ['iframe', 'script']
};

export const sanitizeNoteHtml = (html) => {
  if (typeof html !== 'string') return '';

  return DOMPurify.sanitize(html, SANITIZE_CONFIG);
};

export default sanitizeNoteHtml;
